/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Totp_Remove_SuccessInputs */



/**
* | output |
* | --- |
* | "Authenticator device removed." |
*
* @param {Profile_Security_Totp_Remove_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_remove_success = /** @type {((inputs?: Profile_Security_Totp_Remove_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Remove_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authenticator-Gerät entfernt.")
	return /** @type {LocalizedString} */ ("Authenticator device removed.")
});